// @flow

import React from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';

const Root = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Smile = styled.h2`
  margin: 0;

  font-family: 'PF DIN';
  font-size: 60px;
  font-weight: 300;
`;

const Title = styled.h1`
  margin: 0;

  font-family: 'PF DIN';
  font-size: 120px;
`;

function Error404() {
  return (
    <Root>
      <Helmet>
        <title>Page not found</title>
      </Helmet>

      <Smile>v______________v</Smile>
      <Title>404</Title>
    </Root>
  )
}

export default Error404;



// WEBPACK FOOTER //
// ./src/components/Error404.js